<template>
<v-container >
  <v-app>
    <v-main>
      <Home/>
    </v-main>
  </v-app>
 </v-container> 
</template>

<script>
import Home from './views/Home';

export default {
  name: 'App',
  components: {
    Home,
  },

  created() {
    //console.log(this.$route.params.test)   
  },

  data: () => ({
    //
  }),
};
</script>